<template>
  <ul 
    v-if="conversations.length"
    class="conversations-list py-4"
    data-locator="conversations-list"
  >
    <template v-for="group, index in conversations" :key="index">
      <li class="px-7 py-2">
        <span class="text--extra-bold">{{ $t(`${TRANSLATION_KEY_PREFIX}.groups.${group.label}`) }}</span>
      </li>
      <template v-for="conversation in group.conversations" :key="conversation.id">
        <li class="px-4">
          <AIAssistantConversationsListItem :conversation="conversation" />
        </li>
      </template>
    </template>
    <li data-locator="conversations-list-disclaimer" class="conversations-list__disclaimer py-8">
      <span>{{ $t(`${TRANSLATION_KEY_PREFIX}.disclaimer`) }}</span>
    </li>
  </ul>
  <div 
    v-else-if="getConversationsPending"
    class="py-4"
    data-locator="loading-conversations-list"
  >
    <v-skeleton-loader type="paragraph@3" />
  </div>
  <div 
    v-else 
    class="pa-6"
    data-locator="empty-conversations-list"
  >
    {{ $t(`${TRANSLATION_KEY_PREFIX}.emptyState`) }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'

import AIAssistantConversationsListItem from '@/common/ai-assistant/AIAssistantConversationsListItem.vue'
import { AIAssistantActionTypes } from '@/store/modules/ai-assistant/action_types'
import type { AIAssistantConversation } from '@/types/ai-assistant'


const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantConversationsList'

export default defineComponent({
  name: 'AIAssistantConversationsList',
  data() {
    return {
      TRANSLATION_KEY_PREFIX,
      conversations: [] as { label: string; conversations: AIAssistantConversation[] }[],
    }
  },
  components: {
    AIAssistantConversationsListItem,
  },
  computed: {
    ...mapState('aiAssistant', ['isPaneOpened','getConversationsPending', 'conversationActiveId']),
  },
  methods: {
    ...mapActions('aiAssistant', [ AIAssistantActionTypes.GET_CONVERSATIONS ]),
    async getConversations() {
      try {
        const response = await this.GET_CONVERSATIONS()

        this.conversations = Object.keys(response).map(label => ({
          label,
          conversations: response[label],
        })).filter(group => group.conversations.length > 0)

      } catch (error) {
        console.error('Error fetching conversations:', error)
      }
    },
  },
  watch: {
    isPaneOpened: {
      handler (newVal:boolean) {
        if (newVal) {
          this.getConversations()
        }
      },
      immediate: true,
    },
    conversationActiveId: {
      handler (newVal: number, oldVal: number) {
        // Refresh if a new conversation has just been created (transition from null to an ID)
        if (!oldVal && newVal) {
          this.getConversations()
        }
      },
    },
  },
})
</script>

<style scoped>
.conversations-list__disclaimer {
  color: #2A476A;
  text-align: center;
}
</style>